// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"cfbca808","522":"eeac3c2f","560":"62b9e3ab","787":"5bc9f5c2"}[chunkId] + ".chunk.js";
};